import React, { FunctionComponent } from 'react';
import SocialMediaAccount from '../../../networking/models/SocialMediaAccount';
import SocialMediaIcon from '../../admin/partials/university/SocialMediaIcon';

interface Props {
    accounts: SocialMediaAccount[];
}

const MediaAccountList: FunctionComponent<Props> = ({ accounts }) => {

    return (
        <div className={'media-icons'}>
            { accounts.map(account => (
                <SocialMediaIcon
                    name={account.slug}
                    to={account.url}
                    className={'media-icons__icon'}
                    key={account.slug} />
            )) }
        </div>
    );
};

export default MediaAccountList;
